import type { ReactNode } from 'react';

import { cn } from './cn';

// EmptyState — the one "nothing here" block for lists / panels (ARCHITECTURE
// §8.2). Replaces ad-hoc "No X yet" alerts and centered divs. Presentational.

export interface EmptyStateProps {
  /** Optional leading glyph/icon node. */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Optional call-to-action (e.g. a <Button>). */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn('flex flex-col items-center gap-2 px-6 py-14 text-center', className)}
      role="status"
    >
      {icon ? (
        <div className="mb-1 grid h-12 w-12 place-items-center rounded-full bg-surface text-muted">
          {icon}
        </div>
      ) : null}
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      {description ? <p className="max-w-md text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
